import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CatalogEffects, catalogKey, reducer as catalogReducer } from './catalog';
import { CurrUserEffects, currUserKey, reducer as currUserReducer } from './curr-user';
import { currencyKey, reducer as currencyReducer } from './currency';
import { CurrencyEffects } from './currency/currency.effects';
import { docsIdKey, reducer as docsIdReducer } from './docs-id';
import { reducer as systemOptionsReducer, SystemOptionsEffects, systemOptionsKey } from './system-options';
import { reducer as utilsReducer, utilsKey } from './utils';
import { UtilsEffects } from './utils/utils.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(currUserKey, currUserReducer),
        StoreModule.forFeature(currencyKey, currencyReducer),
        StoreModule.forFeature(docsIdKey, docsIdReducer),
        StoreModule.forFeature(systemOptionsKey, systemOptionsReducer),
        StoreModule.forFeature(utilsKey, utilsReducer),
        StoreModule.forFeature(catalogKey, catalogReducer),
        EffectsModule.forFeature([CurrUserEffects]),
        EffectsModule.forFeature([CurrencyEffects]),
        EffectsModule.forFeature([SystemOptionsEffects]),
        EffectsModule.forFeature([UtilsEffects]),
        EffectsModule.forFeature([CatalogEffects]),
    ],
})
export class PromanStoreModule {}
